export enum Role {
    None = 0,
    User = 1,
    BrandCompanyContact = 2,
    MarketCompanyContact = 3,
    TraceTeam = 4,
    BSTeam = 5,
    Administrator = 6,
}
